import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_InventoryBus } from "./v_InventoryBus";
import { InventoryLocationXrefBus } from "./InventoryLocationXrefBus";
import { InventoryThresholdOverrideBus } from "./InventoryThresholdOverrideBus";
import { InventorySupplierXrefBus } from "./InventorySupplierXrefBus";
import { InventoryBus } from "./InventoryBus";
import { InventoryConsumablesBus } from "./InventoryConsumablesBus";
import { InventoryConsMatchesBus } from "./InventoryConsMatchesBus";
import { InventoryThresholdOverrideBranchBus } from "./InventoryThresholdOverrideBranchBus";
import { InventoryPartNbrsBus } from "./InventoryPartNbrsBus";
import { PricingProjectionRollupDetail } from "./PricingProjectionRollupDetail";

export class PricingProjectionRollup extends BaseBus
{
    constructor(data: PricingProjectionRollup) {
        super();
        if (data) {

            this.billingCode = data.billingCode;
            this.newPrice = data.newPrice;
            this.details = data.details;
        }
    }

    CID(): any {
        return this.billingCode;
    }
    setId(id: any) {
        this.billingCode = id;
    }
    initialize(data: PricingProjectionRollup) {
        super.initialize(data);

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setBeforeSave() {
    }
    setCommon(userId: any, date: Date, companyId: any = null) {

    }

    billingCode: string;
    billingGroup: string;
    newPrice: number;
    details: PricingProjectionRollupDetail[];
    values: number[]

}
